import { styled } from 'stitches.config';

export const SafetyQualityRoot = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '$4',
  background: '$tertiary-200',

  '@bp2': {
    flexDirection: 'row',
    justifyContent: 'center',
    padding: '$6',
    paddingBottom: '$14',
    alignItems: 'flex-start',
  },
});

export const SectionWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  marginBottom: '$4',
  maxWidth: '300px',

  '@bp2': {
    marginBottom: 0,
    maxWidth: '580px',
    padding: '0 $7',
  },
});

export const Header = styled('h3', {
  color: '$accent-black',
  textAlign: 'center',
  fontFamily: '$primary',
  fontSize: '$h4',
  fontWeight: '$semiBold',
  lineHeight: '45px',
  marginBottom: '$2',
});

export const Description = styled('p', {
  color: '$accent-black',
  textAlign: 'center',
  fontFamily: '$primary',
  fontSize: '$body',
  fontWeight: '$regular',

  '@bp2': {
    fontSize: '$bodyLarge',
  },
});

export const BorderWrapper = styled('div', {
    background: '$tertiary-200',
    paddingBottom: '60px',
    position: 'relative',
  
    '@bp3': {
      paddingBottom: '130px'
    }
  })



export const BadgeWrapper = styled('div', {
    position: 'absolute',
    width: '150px',
    top: '-31px',
    left: 0,
    right: 0,
    margin: 'auto',
    zIndex: 2,
    display: 'block',
    textAlign: 'center',
    '@bp3': {
      display: 'block',
      width: '240px',
    }
  })